var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantaneousMultiplayerAssistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.243 85.7076C113.069 85.7076 105.89 85.6837 98.7165 85.7315C97.6103 85.741 97.2751 85.4448 97.3086 84.3316C97.39 81.5986 97.3996 78.8561 97.323 76.1184C97.1841 71.1494 99.3774 67.437 103.328 64.6228C104.578 63.7341 105.967 63.0987 107.327 62.4011C108.912 61.5936 110.153 61.6844 111.738 62.7833C117.154 66.5387 124.443 66.2616 129.787 62.3055C130.611 61.694 131.267 61.5745 132.211 61.9424C134.892 62.9792 137.383 64.3027 139.471 66.3046C142.119 68.8465 143.422 71.9664 143.46 75.6119C143.489 78.4548 143.412 81.2976 143.493 84.1405C143.527 85.354 143.22 85.7506 141.932 85.741C134.706 85.6742 127.474 85.7076 120.248 85.7076H120.243Z",
    fill: "url(#paint0_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.613 74.241C155.873 74.241 152.133 74.2458 148.392 74.2362C147.794 74.2362 147.147 74.3987 147.023 73.4049C146.3 67.5711 142.976 63.4956 138.039 60.6288C136.861 59.9456 136.995 59.549 137.809 58.7463C139.408 57.1649 141.295 56.0564 143.34 55.1773C143.972 54.9049 144.446 54.9766 145.04 55.4257C150.466 59.5156 156.634 59.5251 162.079 55.4544C162.716 54.9814 163.224 54.9049 163.928 55.2107C168.324 57.1219 172.701 60.3613 172.318 67.38C172.222 69.1621 172.232 70.9586 172.328 72.7408C172.39 73.9161 172.026 74.2888 170.834 74.2649C167.093 74.1932 163.353 74.241 159.613 74.241Z",
    fill: "url(#paint1_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8441 74.2408C77.262 74.2408 73.675 74.1978 70.0929 74.2647C68.91 74.2886 68.3928 74.0449 68.479 72.7262C68.5987 70.8389 68.6035 68.9373 68.4934 67.0501C68.1677 61.5985 70.9645 58.1728 75.5427 55.7838C76.9459 55.0528 77.9995 54.9047 79.4697 55.9941C84.1533 59.4628 90.5418 59.3242 95.211 55.7695C96.279 54.9573 97.0787 54.9573 98.161 55.4972C99.8707 56.3476 101.465 57.3319 102.849 58.6601C103.711 59.4867 103.86 59.9645 102.624 60.6812C98.2664 63.2087 95.1488 66.7682 93.9755 71.7945C93.4056 74.2408 93.396 74.2408 90.81 74.2408C87.4912 74.2408 84.1677 74.2408 80.8489 74.2408H80.8441Z",
    fill: "url(#paint2_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.531 49.5727C132.493 56.3621 127.005 61.7563 120.195 61.6894C113.562 61.6273 108.05 55.999 108.146 49.3864C108.247 42.6113 113.72 37.3461 120.616 37.3939C127.23 37.4417 132.565 42.8932 132.531 49.5727Z",
    fill: "url(#paint3_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.463 45.0001C163.425 50.3896 158.943 54.7757 153.502 54.7422C148.1 54.7136 143.647 50.2176 143.685 44.8377C143.723 39.4291 148.196 34.9857 153.589 35C159.081 35.0144 163.502 39.4912 163.463 45.0001Z",
    fill: "url(#paint4_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0021 44.8809C97.0021 50.3325 92.6297 54.7329 87.1943 54.7425C81.6774 54.7568 77.2667 50.3181 77.3051 44.7997C77.3434 39.3529 81.7827 34.962 87.1991 35.0002C92.6633 35.0432 97.0021 39.415 97.0021 44.8761V44.8809Z",
    fill: "url(#paint5_linear_75_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.458 157.524C99.66 156.879 89.8666 156.225 80.0683 155.589C76.9986 155.389 73.9193 155.255 70.8496 155.035C70.1408 154.982 69.6188 155.283 69.0777 155.599C63.7044 158.685 58.336 161.786 52.958 164.873C49.4668 166.879 47.0245 166.234 45.0083 162.751C38.6725 151.805 32.3367 140.854 26.0105 129.899C24.1572 126.693 24.8611 124.16 28.0697 122.311C40.9712 114.877 53.8919 107.471 66.7694 99.9986C72.8562 96.4677 79.2351 95.5074 86.0498 97.3517C96.4227 100.151 106.81 102.884 117.188 105.675C122.93 107.218 126.603 111.829 126.584 117.39C126.569 122.818 122.93 127.495 117.599 128.929C115.555 129.478 113.514 129.44 111.474 128.89C104.779 127.089 98.0796 125.307 91.3799 123.511C88.3341 122.694 85.9971 123.568 84.9148 125.947C83.6361 128.761 85.2404 131.719 88.5592 132.608C93.8223 134.017 99.0949 135.407 104.363 136.793C107.428 137.601 110.44 138.652 113.673 138.699C125.267 138.876 134.308 131.251 135.936 119.822C136.047 119.043 136.31 118.618 136.976 118.236C143.647 114.423 150.27 110.52 156.97 106.759C162.951 103.4 170.082 105.359 173.391 111.136C176.667 116.86 174.823 123.984 168.942 127.405C153.368 136.459 137.737 145.417 122.115 154.39C118.208 156.636 113.979 157.663 109.458 157.529V157.524Z",
    fill: "url(#paint6_linear_75_58)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_58",
    x1: 120.401,
    y1: 61.7344,
    x2: 120.401,
    y2: 85.7412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_58",
    x1: 154.759,
    y1: 55.0176,
    x2: 154.759,
    y2: 74.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_58",
    x1: 85.9957,
    y1: 55.1211,
    x2: 85.9957,
    y2: 74.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_58",
    x1: 120.338,
    y1: 37.3936,
    x2: 120.338,
    y2: 61.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_58",
    x1: 153.574,
    y1: 35,
    x2: 153.574,
    y2: 54.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_58",
    x1: 87.1534,
    y1: 35,
    x2: 87.1534,
    y2: 54.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_58",
    x1: 100,
    y1: 96.4336,
    x2: 100,
    y2: 166.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 131,
    fill: "white",
    transform: "translate(25 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantaneousMultiplayerAssistance);
export default __webpack_public_path__ + "static/media/Instantaneous_Multiplayer_Assistance.35ed9e4ee1b18b8a6ff98bb3c5f466c4.svg";
export { ForwardRef as ReactComponent };